import Card from 'components/pages/financing-for-companies/items/Card';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useCommonData from 'hooks/useCommonData';
import { QUERY } from 'interfaces/graph';
import React, { useState } from 'react';
import { isMobileScreen } from 'utils/helper';

const shouldBeOpen = (currentView, view) => {
	if(isMobileScreen()) {
		return currentView === view;
	}
	return currentView;
};

export default function CardView() {
	const { secureFinancing } = useCommonData(QUERY.SECURE_FINANCING_DESC);
	const [currentCardId, setCurrentCardId] = useState(null);
	const { t } = useTranslation();

	const handleClosePlan = () => {
		setCurrentCardId(null);
	};

	const handleOpenPlan = id => () => {
		setCurrentCardId(id);
	};

	if(!secureFinancing) return null;

	return (
		<div>
			<div className='grid sm:grid-cols-4-min gap-x-04 xl:gap-x-12 gap-y-60 sm:gap-y-30 items-center justify-center mb-30 sm:mb-0 mt-30'>
				<Card
					isGreen
					isOpen={shouldBeOpen(currentCardId, 1)}
					title={t('pageFinancingForCompany.whyFinteq.card.1.title')}
					description={secureFinancing.finteqDescription}
					onOpen={handleOpenPlan(1)}
					onClose={handleClosePlan}
				/>
				<Card
					isOpen={shouldBeOpen(currentCardId, 2)}
					title={t('pageFinancingForCompany.whyFinteq.card.2.title')}
					description={secureFinancing.creditDescription}
					onOpen={handleOpenPlan(2)}
					onClose={handleClosePlan}
				/>
				<Card
					isOpen={shouldBeOpen(currentCardId, 3)}
					title={t('pageFinancingForCompany.whyFinteq.card.3.title')}
					description={secureFinancing.factoringDescription}
					onOpen={handleOpenPlan(3)}
					onClose={handleClosePlan}
				/>
				<Card
					isOpen={shouldBeOpen(currentCardId, 4)}
					title={t('pageFinancingForCompany.whyFinteq.card.4.title')}
					description={secureFinancing.loanDescription}
					onOpen={handleOpenPlan(4)}
					onClose={handleClosePlan}
				/>
			</div>
		</div>
	);
}
